<template>
    <div>
        <el-card class="search-form-card">
            <el-form :inline="true" :model="form" class="search-form">
                <el-form-item label="用户名:">
                    <el-input v-model="form.keyword" @keyup.enter.native="request" class="common-input"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="loadData">搜索</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <el-card>
            <el-table :data="tableData" v-loading="loading">
                <el-table-column label="用户名" prop="user" ></el-table-column>
                <el-table-column label="中文名" prop="name" ></el-table-column>
                <el-table-column label="登录时间" prop="loginTime"></el-table-column>
                <el-table-column label="IP" prop="ip"></el-table-column>

                <el-table-column label="个人信息">
                    <template slot-scope="scope">
                        <router-link :to="{path:'/onlineUsersView',query:{internalUserid:scope.row.user}}">
                            <el-button type="text" >查看详细</el-button>
                        </router-link>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" min-width="120">
                    <template slot-scope="scope">
                        <el-button v-w-role="" class="table-del-btn" type="text" @click="forceOfflineUser(scope.row.user,scope.row.name)">强制下线</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.pageIndex"
                           :page-sizes="[10,20]"
                           :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
    // import { statusLists } from "./event.config";
    import services from "./system.service";
    import commonService from "../../services/common.service";
    export default {
        data() {
            return {
                form:{
                    keyword:'',
                    pageSize:10,
                    pageIndex:1,
                },
                total:null,
                tableData:[],
                loading:false,
            }
        },
        created() {
            this.request();
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },


        },
        methods: {

            loadData(){
                this.form.pageIndex = 1;
                // this.tableData = [];
                // this.total = null;
                // this.loading = true;
                this.request();
            },
            request(){
                // 获取列表数据
                services.getOnlineUsersList(this.form).then(res => {
                    this.tableData = res.users;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            forceOfflineUser(userid,name){
                this.openMessage(`确定要将'${name}'用户强制下线吗？`, '确定', () => {
                    let currentUser=window.localStorage.getItem('name')
                    let params={
                        currentUser,
                        username:userid
                    }
                    services.forceOffline(params).then(res => {
                        this.$message.success("强制下线成功");
                        this.request();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.request();
            },

        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
